import { Brand } from "~/entities/brandEntities";

type BrandConfig = {
  Brand: Brand;
};

export const brandConfig: BrandConfig = {
  Brand: import.meta.env.VITE_BRAND || Brand.DNERO,
};
